import { TemplatePage } from './types';

const liveStreamGeometricTheme: TemplatePage = {
  header: {
    color: '#FFF5EB',
    icon: 'images/video-templates/geometric_theme.jpg',
    title: 'Live Stream Templates — Geometric Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Geometric Theme',
    description_meta:
      'Make your live streams look highly professional with Wave.video’s geometric-themed templates. ' +
      'Get a complete package of free video transitions & overlays.',
    description:
      'Make your live streams look highly professional with our geometric-themed templates. Get a perfect set of ' +
      'pre-designed overlays, transition screens, and frames for multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.`
  },
  footer: {
    category: 'Live streaming geometric theme',
    description:
      'With Wave.video’s themed collections of editable overlay and transition screen templates, you will impress ' +
      'your viewers without much effort. Pick a set of templates that matches your brand book and easily create a ' +
      'professional design for your live streams. Create countdown, intro, outro, transparent lower third, technical ' +
      'issue screen, and other essential design elements that will take your live streams to the next level! You can ' +
      'quickly adapt your custom design to any multistreaming platform with the help of Wave.video pre-designed layouts.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming geometric theme',
      search: { name: 'GeometricTheme', tags: 'GeometricTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamGeometricTheme;
